<div class="body">
  <div class="sticky">
    <app-auth-side-header></app-auth-side-header>
  </div>
  <div class="back-img">
    <div class="back-btn-container container">
      <div nxRow class="std-pd-top-2m">
        <div nxCol="12" class="std-ta-center">
          <span
            class="page-title grey-color module-title-font common-line-height"
          >
            {{ "FIRST_TIME_LOGIN.TITLE" | translate }}
          </span>
        </div>
        <div class="input-container ft-container std-fs-md">
          <form [formGroup]="firstTimeLoginForm" (ngSubmit)="onSubmit()">
            <nx-formfield
              [label]="'FIRST_TIME_LOGIN.FORM.EMAIL' | translate"
              class="full-width"
            >
              <input formControlName="email" nxInput type="email" />
              <nx-error nxFormfieldError>
                {{ "FIRST_TIME_LOGIN.FORM.INVALID_EMAIL" | translate }}
              </nx-error>
            </nx-formfield>

            <nx-formfield
              [label]="'FIRST_TIME_LOGIN.FORM.PREFERRED_NAME' | translate"
              class="full-width"
            >
              <input formControlName="name" nxInput type="text" />
              <nx-icon
                class="update-contact-pop"
                size="s"
                nxFormfieldAppendix
                nxPopoverDirection="right"
                nxPopoverTrigger="hover"
                [nxPopoverTriggerFor]="popoverUpdateContactDetails"
              ></nx-icon>
              <div>
                <nx-popover #popoverUpdateContactDetails>
                  <span
                    class="pop-over std-fs-md std-fw-normal"
                    [innerHTML]="
                      'FIRST_TIME_LOGIN.FORM.PREFERRED_NAME_INFO' | translate
                    "
                  >
                  </span>
                </nx-popover>
              </div>
            </nx-formfield>

            <nx-formfield
              [label]="'FIRST_TIME_LOGIN.FORM.MOBILE_NUMBER' | translate"
              class="full-width"
            >
              <input formControlName="mobileNumber" nxInput type="text" />
              <nx-error nxFormfieldError>
                {{ "FIRST_TIME_LOGIN.FORM.MOBILE_NUMBER_ERROR" | translate }}
              </nx-error>
            </nx-formfield>

            <div>
              <nx-formfield
                [label]="'FIRST_TIME_LOGIN.FORM.NEW_PASSWORD' | translate"
                class="full-width"
              >
                <input formControlName="password" nxInput type="password" />
                @if (firstTimeLoginForm.controls["password"].valid) {
                  <nx-icon class="done-icon"></nx-icon>
                }
                @if (firstTimeLoginForm.controls["password"].invalid) {
                  <nx-message nxFormfieldNote class="label-16-font fw-regular">
                    <div style="margin-bottom: 14px">
                      <nx-icon
                        size="s"
                        name="info-circle"
                        class="info-circle"
                      ></nx-icon>
                      <span>{{ "PASSWORD_VALIDATION.TITLE" | translate }}</span>
                    </div>
                    <div
                      [ngClass]="
                        firstTimeLoginForm.controls['password'].hasError(
                          'required'
                        ) ||
                        firstTimeLoginForm.controls['password'].hasError(
                          'minAndMaxNum'
                        )
                          ? 'text-required'
                          : 'text-success'
                      "
                    >
                      <div class="validator-container">
                        <nx-icon size="s" name="check"></nx-icon>
                      </div>
                      <p>{{ "PASSWORD_VALIDATION.CHAR_LENGTH" | translate }}</p>
                    </div>
                    <div
                      [ngClass]="
                        firstTimeLoginForm.controls['password'].hasError(
                          'required'
                        ) ||
                        firstTimeLoginForm.controls['password'].hasError(
                          'hasAlphanumeric'
                        )
                          ? 'text-required'
                          : 'text-success'
                      "
                    >
                      <div class="validator-container">
                        <nx-icon size="s" name="check"></nx-icon>
                      </div>
                      <p>
                        {{ "PASSWORD_VALIDATION.ALPHANUMERIC" | translate }}
                      </p>
                    </div>
                    <div
                      [ngClass]="
                        firstTimeLoginForm.controls['password'].hasError(
                          'required'
                        ) ||
                        firstTimeLoginForm.controls['password'].hasError(
                          'uppercaseAndLowercase'
                        )
                          ? 'text-required'
                          : 'text-success'
                      "
                    >
                      <div class="validator-container">
                        <nx-icon size="s" name="check"></nx-icon>
                      </div>
                      <p>{{ "PASSWORD_VALIDATION.CASE" | translate }}</p>
                    </div>
                    <div
                      [ngClass]="
                        firstTimeLoginForm.controls['password'].hasError(
                          'required'
                        ) ||
                        firstTimeLoginForm.controls['password'].hasError(
                          'hasSpecialCharacters'
                        )
                          ? 'text-required'
                          : 'text-success'
                      "
                    >
                      <div class="validator-container">
                        <nx-icon size="s" name="check"></nx-icon>
                      </div>
                      <p>
                        {{ "PASSWORD_VALIDATION.SPECIAL_CHAR" | translate }}
                      </p>
                    </div>
                  </nx-message>
                }
              </nx-formfield>

              <nx-formfield
                [label]="
                  'FIRST_TIME_LOGIN.FORM.CONFIRM_NEW_PASSWORD' | translate
                "
                class="full-width"
              >
                <input
                  formControlName="confirmPassword"
                  nxInput
                  type="password"
                />
                @if (
                  firstTimeLoginForm.controls["password"].valid &&
                  firstTimeLoginForm.controls["password"].value ===
                    firstTimeLoginForm.controls["confirmPassword"].value
                ) {
                  <nx-icon class="done-icon"></nx-icon>
                }
                <nx-error nxFormfieldError>
                  @if (confirmPasswordErrorType === "required") {
                    <b>{{ "FORM_ERRORS.PLEASE_NOTE" | translate }}</b>
                    {{
                      "FIRST_TIME_LOGIN.FORM.CONFIRM_PASSWORD_REQUIRED"
                        | translate
                    }}
                  }
                  @if (confirmPasswordErrorType === "passwordMisMatch") {
                    <p class="error-title match-error-title">
                      {{
                        "FIRST_TIME_LOGIN.FORM.PASSWORD_MISMATCH_TITLE"
                          | translate
                      }}
                    </p>
                    <p class="match-error-text">
                      {{
                        "FIRST_TIME_LOGIN.FORM.PASSWORD_MISMATCH_TEXT"
                          | translate
                      }}
                    </p>
                  }
                </nx-error>
              </nx-formfield>
            </div>

            <nx-formfield
              [label]="'FIRST_TIME_LOGIN.FORM.SECRET_QUESTION' | translate"
              class="secret-question-field"
            >
              <nx-dropdown formControlName="secretQuestion" nxInput>
                @for (
                  secretQuestion of secretQuestionList$ | async;
                  track secretQuestion
                ) {
                  <nx-dropdown-item [value]="secretQuestion.code">
                    <p class="dropdown-field">
                      {{ secretQuestion.descp }}
                    </p>
                  </nx-dropdown-item>
                }
              </nx-dropdown>
              <nx-error nxFormfieldError>
                {{ "FIRST_TIME_LOGIN.FORM.SELECT_SECRET_QUESTION" | translate }}
              </nx-error>
            </nx-formfield>

            <nx-formfield
              [label]="'FIRST_TIME_LOGIN.FORM.SECRET_ANSWER' | translate"
              class="full-width"
            >
              <input
                #secretAnswer
                formControlName="secretAnswer"
                nxInput
                type="password"
              />
              <nx-password-toggle
                [control]="secretAnswer"
                [appPasswordTouchToggle]="secretAnswerToggle"
                #secretAnswerToggle
                ariaLabel="Show password"
                nxFormfieldSuffix
              ></nx-password-toggle>
              <nx-error nxFormfieldError>
                <b>{{ "FORM_ERRORS.PLEASE_NOTE" | translate }}</b>
                {{ "FIRST_TIME_LOGIN.FORM.SECRET_ANSWER_REQUIRED" | translate }}
              </nx-error>
            </nx-formfield>

            <nx-formfield
              [label]="
                'FIRST_TIME_LOGIN.FORM.CONFIRM_SECRET_ANSWER' | translate
              "
              class="full-width"
            >
              <input
                #confirmSecretAnswer
                formControlName="confirmSecretAnswer"
                nxInput
                type="password"
              />
              <nx-password-toggle
                [control]="confirmSecretAnswer"
                [appPasswordTouchToggle]="confirmSecretAnswerToggle"
                #confirmSecretAnswerToggle
                ariaLabel="Show password"
                nxFormfieldSuffix
              ></nx-password-toggle>

              <nx-error nxFormfieldError>
                @if (confirmSecretAnswerErrorType === "required") {
                  <b>{{ "FORM_ERRORS.PLEASE_NOTE" | translate }}</b>
                  {{
                    "FIRST_TIME_LOGIN.FORM.SECRET_ANSWER_REQUIRED" | translate
                  }}
                }
                @if (confirmSecretAnswerErrorType === "secretAnswerMisMatch") {
                  <p class="error-title match-error-title">
                    {{
                      "FIRST_TIME_LOGIN.FORM.SECRET_ANSWER_MISMATCH_TITLE"
                        | translate
                    }}
                  </p>
                  <p class="match-error-text">
                    {{
                      "FIRST_TIME_LOGIN.FORM.SECRET_ANSWER_MISMATCH_TEXT"
                        | translate
                    }}
                  </p>
                }
              </nx-error>
            </nx-formfield>

            <div class="tou-container">
              <nx-checkbox
                formControlName="acknowledgeChecked"
                class="tou-checkbox"
              >
              </nx-checkbox>
              <p class="tou-text grey-color label-14-font common-line-height">
                {{ "FIRST_TIME_LOGIN.FORM.TOU_ACKNOWLEDGEMENT" | translate }}
                <b
                  class="tou-bold fw-bold"
                  (click)="toggleTermOfUse()"
                  (keydown.enter)="toggleTermOfUse()"
                  tabindex="0"
                  role="button"
                >
                  {{ "FIRST_TIME_LOGIN.FORM.TOU_LINK_TEXT" | translate }}
                </b>
                {{
                  "FIRST_TIME_LOGIN.FORM.TOU_ACKNOWLEDGEMENT_SUFFIX" | translate
                }}
              </p>
            </div>

            @if (firstTimeLoginErrorMsg) {
              <nx-error nxFormfieldError class="std-pd-top-m">
                {{ firstTimeLoginErrorMsg }}
              </nx-error>
            }

            <div class="std-pd-top-3m gap-60 ie-padding2">
              <button
                nxButton
                type="submit"
                [disabled]="
                  !firstTimeLoginForm.valid ||
                  firstTimeLoginForm.get('acknowledgeChecked').value === false
                "
                class="site-header__button std-mg-bottom-m"
                nxButton="block primary"
              >
                {{ "FIRST_TIME_LOGIN.FORM.SAVE_AND_UPDATE" | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
